import styled from '@emotion/styled'

const StyledIcon = styled.div`
  float: left;
  padding: 0.2rem 0.3rem 0 0.2rem;
  line-height: 20px;
  cursor: pointer;
  /* border:1px solid red; */
  box-sizing: border-box;
`
export default StyledIcon
